import React from 'react';

export const Laundry = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M17 24.2C17 20.2235 20.2236 17 24.2 17C28.1764 17 31.4 20.2236 31.4 24.2C31.4 28.1764 28.1764 31.4 24.2 31.4C20.2235 31.4 17 28.1764 17 24.2Z'
                fill='currentColor'
            />
            <path
                d='M2.59998 15.8C2.59998 12.4863 5.28627 9.80005 8.59998 9.80005C11.9137 9.80005 14.6 12.4863 14.6 15.8001C14.6 19.1138 11.9137 21.8 8.59997 21.8C5.28627 21.8 2.59998 19.1138 2.59998 15.8Z'
                fill='currentColor'
            />
            <path
                d='M17 6.19997C17 4.21175 18.6118 2.59998 20.6 2.59998C22.5882 2.59998 24.2 4.21175 24.2 6.19998C24.2 8.1882 22.5882 9.79998 20.6 9.79997C18.6118 9.79997 17 8.1882 17 6.19997Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default Laundry;
